import React from 'react'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import PropTypes from 'prop-types'
import { Map } from 'immutable'
import ButtonToggle from '../../ButtonToggle/index'
import { getBoundActions } from '../../../actions/index'
import { connect as connectStaticText } from '../../StaticText/connect'
import { NOTIFICATIONS_RECOMMENDED_PERMISSION_TOGGLED_GA4_EVENT } from '../../../services/event-tracking/index'

const NotificationRecommendedSettings = (props) => {
  const { recommendedNotificationsEnabled, staticText, setFeatureTrackingDataPersistent } = props

  const onSettingsChange = () => {
    setFeatureTrackingDataPersistent({
      data: Map({ recommendedNotificationsEnabled: !recommendedNotificationsEnabled }),
    })
  }
  // GA4 event
  const ga4EventData = NOTIFICATIONS_RECOMMENDED_PERMISSION_TOGGLED_GA4_EVENT.mergeDeep({
    changed_to: !recommendedNotificationsEnabled ? 'on' : 'off',
  })

  return (
    <div className="my-account-settings-V2__notification-settings-controls">
      <div className="my-account-settings-V2__notification-settings-text-container">
        <div className="my-account-settings-V2__notification-settings-title">
          { staticText.getIn(['data', 'notificationsRecommendedHeader']) }
        </div>
        <div className="my-account-settings-V2__notification-settings-text">
          { staticText.getIn(['data', 'notificationsRecommendedBody']) }
        </div>
      </div>
      <div className="my-account-settings-V2__notification-settings-toggle">
        <ButtonToggle
          checked={recommendedNotificationsEnabled}
          onChange={onSettingsChange}
          showLabel
          ga4EventData={ga4EventData}
          round
        />
      </div>
    </div>
  )
}

NotificationRecommendedSettings.propTypes = {
  recommendedNotificationsEnabled: PropTypes.bool,
  setFeatureTrackingDataPersistent: PropTypes.func.isRequired,
}

export default compose(
  connectRedux(
    (state) => {
      return {
        recommendedNotificationsEnabled: state.featureTracking.getIn(['data', 'recommendedNotificationsEnabled'], false),
      }
    },
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setFeatureTrackingDataPersistent: actions.featureTracking.setFeatureTrackingDataPersistent,
      }
    },
  ),
  connectStaticText({ storeKey: 'myAccountSettingsV2' }),
)(NotificationRecommendedSettings)
